import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { CapitalizationPresentation } from "./components/CapitalizationPresentation";

export const CapitalizationPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<CapitalizationPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
